import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const styles = {
  card: css`
    box-shadow: ${theme.shadows.light};
    border-radius: ${theme.borderRadius.medium};
    padding: ${theme.spacing(2)};
    background: ${theme.colors.white};
  `,
  header: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(2)};
  `,
  date: css`
    font-size: ${theme.font.size.large};
    font-weight: ${theme.font.weight.bold};
  `,
  infoBlocks: (v2UI?: boolean) => css`
    display: flex;
    gap: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(1)};
    justify-content: ${v2UI ? 'space-between' : 'flex-start'};
  `,
  infoBlock: css`
    min-width: 70px;

    label {
      font-size: ${theme.font.size.small};
      color: ${theme.colors.text.subdued};
      font-weight: ${theme.font.weight.regular};
    }
    div {
      font-weight: ${theme.font.weight.bold};
      font-size: ${theme.font.size.medium};
    }
  `,
  recentActivities: css`
    margin: ${theme.spacing(2, 0)};
  `,
  recentActivityButton: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
  actions: css`
    display: flex;
    gap: ${theme.spacing(1)};
  `,
  actionFullButton: css`
    flex-grow: 1;
    button {
      width: 100%;
    }
  `,
  actionMiniButton: css`
    flex-grow: 0;
    button {
      width: auto;
    }
  `,
  recentActivityDetails: css`
    margin-top: ${theme.spacing(1)};
    padding: ${theme.spacing(1, 2)};
    border-left: 1px solid ${theme.colors.neutral20};
  `,
};
